import { setItem, removeItem } from "@lib/storage";
import { actions as authActions } from "@reducers/authReducer";
import { actions as configActions } from "@reducers/configReducer";
import { all, call, put, takeLatest } from "redux-saga/effects";

import { getAppBootParams } from "@services/api";
import * as Sentry from "@sentry/react-native";
import {
  AUTH_ACTIONS,
  SET_LOGIN_RELATED_PARAMS,
} from "../reducers/actionTypes";

function* setNewUser() {
  yield all({
    newlyCreatedUser: setItem("newlyCreatedUser", "true"),
    navigateWhatsappScreenForNewUser: setItem(
      "navigateWhatsappScreenForNewUser",
      "true",
    ),
    showWelcomeTLtoTlToNew: setItem(
      "showWelcomeTLtoTlToNew",
      "true",
    ),
    signupSessionVideo: setItem("signupSessionVideo", "true"),
    startSession: setItem("startSession", "true"),
    signup_add_req: setItem("signup_add_req", "true"),
  });
  yield put(
    authActions.setNewUser({
      newlyCreatedUser: true,
      navigateWhatsappScreenForNewUser: true,
      showWelcomeTLtoTlToNew: true,
      signupSessionVideo: true,
      startSession: true,
      signup_add_req: true,
    }),
  );
}

function* removeNewUser() {
  yield all({
    newlyCreatedUser: removeItem("newlyCreatedUser"),
    isUserLoggedInFirst: removeItem("isUserLoggedInFirst"),
  });
  yield put(
    authActions.removeNewUser({
      newlyCreatedUser: null,
      isUserLoggedInFirst: null,
    }),
  );
}

// TODO ADD ANOTHER SAGA TO UPDATE newlyCreatedUser, isUserLoggedInFirst IN THE REDUX STORE

function* signoutUser() {
  const { token, isUserLoggedIn } = yield all({
    token: removeItem("user_token"),
    isUserLoggedIn: removeItem("isUserLoggedIn"),
  });
  yield put(
    authActions.signOut({
      token: null,
      isUserLoggedIn: null,
    }),
  );
  yield put({ type: "RESET_REDUX" });
}

function* restoreUserToken(action) {
  yield put(configActions.syncUser(false));
}

function* signInEffect({ payload: { verifyOtpResponse, userToken } }) {
  if (!userToken) {
    Sentry.captureMessage("signInEffect: missing userToken", {
      extra: { verifyOtpResponse },
    });
    return;
  }
  const { teamLeader = {} } = verifyOtpResponse || {};

  const meParams = {
    userToken,
    discardedAt: teamLeader.discarded_at,
    rejectedAt: teamLeader.rejected_at,
    leaderState: teamLeader.leader_state,
    userName: teamLeader.name,
    alreadyCx: teamLeader.already_a_cx,
    alreadyCxWoOrder: teamLeader.already_a_cx_wo_order,
  };

  yield all([
    call(setItem, "user_token", userToken),
    call(setItem, "showCLToCLWelcome", "true"),
  ]);
  try {
    const { data: bootParams } = yield call(getAppBootParams);
    const { meResponse } = bootParams || {};
    const setupParams = {
      userPincode: meResponse.pincode,
      deviceGeog: meResponse.device_location_geog,
      isServiceable: meResponse.is_serviceable,
      lat: meResponse.lat,
      lng: meResponse.lng,
    };
    yield put(
      authActions.setLoginParams({
        meParams,
        setupParams,
      }),
    );
    yield put(
      configActions.syncUser({
        userToken,
        bootParams,
      }),
    );
  } catch (e) {
    Sentry.captureException(e);
  }
}

export default function* root() {
  yield all([
    takeLatest(AUTH_ACTIONS.SIGN_OUT_USER, signoutUser),
    takeLatest(AUTH_ACTIONS.SET_NEW_USER_REQUEST, setNewUser),
    takeLatest(AUTH_ACTIONS.REMOVE_NEW_USER_REQUEST, removeNewUser),
    takeLatest(AUTH_ACTIONS.RESTORE_USER_TOKEN, restoreUserToken),
    takeLatest(AUTH_ACTIONS.SIGN_IN, signInEffect),
  ]);
}
